import { useTranslation } from "react-i18next";

export function ToggleSwitch({ checked, toggleChecked }: { checked: boolean; toggleChecked: (checked: boolean) => void; }) {
  const { t } = useTranslation();

  return (
    <div className="toggle-switch-container">
      {t('my_activity')}{" "}
      <div className="toggle-switch">
        <input
          type="checkbox"
          className="toggle-switch-checkbox"
          name="myActivity"
          id="myActivity"
          checked={checked}
          onChange={(e) => toggleChecked(e.target.checked)}
        />
        <label className="toggle-switch-label" htmlFor="myActivity">
          <span className="toggle-switch-inner" />
          <span className="toggle-switch-switch" />
        </label>
      </div>
    </div>
  );
}